// Nodejs encryption with CTR
import crypto from 'crypto';

const a = 'aes-256-ctr';
const p = 'chiki-puki';

export function encrypt(text) {
	const cipher = crypto.createCipher(a, p);
	let crypted = cipher.update(text, 'utf8', 'hex');

	crypted += cipher.final('hex');

	return crypted;
}

export function decrypt(text) {
	const decipher = crypto.createDecipher(a, p);
	let dec = decipher.update(text, 'hex', 'utf8');

	dec += decipher.final('utf8');

	return dec;
}

export default {
	encrypt,
	decrypt,
};
